import { __ } from '@/hub-shared/utils/i18n';

export type FieldConfig = {
  key: string;
  label: string;
  inputType?: 'text' | 'date';
  /** Display only — shown as text even in edit mode (e.g. a derived value like SIREN). */
  readOnly?: boolean;
};

export const COMPANY_GENERAL_FIELDS: FieldConfig[] = [
  { key: 'name', label: 'Nom' },
  { key: 'legal_form', label: 'Forme juridique' },
  { key: 'siren', label: 'SIREN' },
  { key: 'fiscal_year_start', label: "Début d'exercice", inputType: 'date' },
  { key: 'fiscal_year_end', label: "Fin d'exercice", inputType: 'date' },
  { key: 'nace_codes', label: 'Code(s) NACE' },
  { key: 'headquarters_address', label: 'Adresse' },
  { key: 'headquarters_postal_code', label: 'Code postal' },
  { key: 'headquarters_town', label: 'Ville' },
  { key: 'headquarters_country', label: 'Pays' },
  { key: 'sector', label: "Secteur d'activité" },
  { key: 'phone', label: 'Téléphone' },
  { key: 'email', label: 'Email' },
];

type GeneralModuleProps = {
  data: Record<string, unknown>;
  isEditing: boolean;
  onChange: (field: string, value: string) => void;
  fields?: FieldConfig[];
};

const formatDateForDisplay = (value: string): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const GeneralModule = ({ data, isEditing, onChange, fields = COMPANY_GENERAL_FIELDS }: GeneralModuleProps) => (
  <>
    {fields.map(({ key, label, inputType = 'text', readOnly = false }) => {
      const rawValue = data[key];
      const value = String(rawValue ?? '');
      const inputId = `general-field-${key}`;
      const editable = isEditing && !readOnly;
      const displayValue =
        inputType === 'date' ? formatDateForDisplay(value) : (value || '—');
      return (
        <div key={key} className="module-fields__row">
          <label htmlFor={editable ? inputId : undefined} className="module-fields__label">
            {__(label)}
          </label>
          {editable ? (
            <input
              id={inputId}
              type={inputType}
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(key, e.target.value)}
              className="module-fields__input"
            />
          ) : (
            <span className="module-fields__value">{displayValue}</span>
          )}
        </div>
      );
    })}
  </>
);

export default GeneralModule;
